const startLo12 = {
    "drawCode": "250001183",
    "drawAt": "2025-08-15T06:30:00.000+00:00",
    "shiftCode": "020",
    "isPopular": true,
    "drawTime": "01:30 PM",
    "status": "AWARDED",
    "isNight": false,
    "isInited": true,
    "title": [],
    "dayOfWeek": "Thứ sáu",
    "header": [
        "Gia Lai",
        "Ninh Thuận",
        "Thừa T. Huế"
    ],
    "subHeader": [
        "2025-08-15 06:30:00",
        "XSGL",
        "XSNT",
        "XSTTH"
    ],
    "results": [
        {
            "code": "Giải tám",
            "items": [
                [
                    "**"
                ],
                [
                    "**"
                ],
                [
                    "**"
                ]
            ]
        },
        {
            "code": "Giải bảy",
            "items": [
                [
                    "***"
                ],
                [
                    "***"
                ],
                [
                    "***"
                ]
            ]
        },
        {
            "code": "Giải sáu",
            "items": [
                [
                    "****",
                    "****",
                    "****"
                ],
                [
                    "****",
                    "****",
                    "****"
                ],
                [
                    "****",
                    "****",
                    "****"
                ]
            ]
        },
        {
            "code": "Giải năm",
            "items": [
                [
                    "*****",
                    "*****",
                    "*****",
                    "*****"
                ],
                [
                    "*****",
                    "*****",
                    "*****",
                    "*****"
                ],
                [
                    "*****",
                    "*****",
                    "*****",
                    "*****"
                ]
            ]
        },
        {
            "code": "Giải tư",
            "items": [
                [
                    "*****",
                    "*****"
                ],
                [
                    "*****",
                    "*****"
                ],
                [
                    "*****",
                    "*****"
                ]
            ]
        },
        {
            "code": "Giải ba",
            "items": [
                [
                    "*****"
                ],
                [
                    "*****"
                ],
                [
                    "*****"
                ]
            ]
        },
        {
            "code": "Giải nhì",
            "items": [
                [
                    "*****"
                ],
                [
                    "*****"
                ],
                [
                    "*****"
                ]
            ]
        },
        {
            "code": "Giải nhất",
            "items": [
                [
                    "*****"
                ],
                [
                    "*****"
                ],
                [
                    "*****"
                ]
            ]
        },
        {
            "code": "Giải Đặc Biệt",
            "items": [
                [
                    "*****"
                ],
                [
                    "*****"
                ],
                [
                    "*****"
                ]
            ]
        }
    ],
    "rightResults": [
        {
            "postCode": "A",
            "twoD": "**",
            "threeD": "***",
            "fiveD": "*****"
        },
        {
            "postCode": "B",
            "twoD": "**",
            "threeD": "***",
            "fiveD": "*****"
        },
        {
            "postCode": "C",
            "twoD": "**",
            "threeD": "***",
            "fiveD": "*****"
        },
        {
            "postCode": "D",
            "twoD": "**",
            "threeD": "***",
            "fiveD": "*****"
        },
        {
            "postCode": "F",
            "twoD": "**",
            "threeD": "***",
            "fiveD": "*****"
        },
        {
            "postCode": "I",
            "twoD": "**",
            "threeD": "***",
            "fiveD": "*****"
        },
        {
            "postCode": "N",
            "twoD": "**",
            "threeD": "***",
            "fiveD": "*****"
        },
        {
            "postCode": "P",
            "twoD": "**",
            "threeD": "***",
            "fiveD": "*****"
        }
    ],
    "slotResults": [
        {
            "columnNumber": 1,
            "release": "",
            "drawing": ""
        },
        {
            "columnNumber": 2,
            "release": "",
            "drawing": ""
        },
        {
            "columnNumber": 3,
            "release": "",
            "drawing": ""
        }
    ]
}

const startLo15 = {
    "drawCode": "250001190",
    "drawAt": new Date(),
    "shiftCode": "029",
    "isPopular": false,
    "drawTime": "02:30 PM",
    "status": "WAITING",
    "isNight": false,
    "isInited": true,
    "title": [],
    "dayOfWeek": "Thứ sáu",
    "header": [
        "Gia Lai",
        "Ninh Thuận",
        "Thừa T. Huế"
    ],
    "subHeader": [
        "2025-08-15 07:30:00",
        "XSGL",
        "XSNT",
        "XSTTH"
    ],
    "results": [
        {
            "code": "Giải tám",
            "items": [
                [
                    "**"
                ],
                [
                    "**"
                ],
                [
                    "**"
                ]
            ]
        },
        {
            "code": "Giải bảy",
            "items": [
                [
                    "***"
                ],
                [
                    "***"
                ],
                [
                    "***"
                ]
            ]
        },
        {
            "code": "Giải sáu",
            "items": [
                [
                    "****",
                    "****",
                    "****"
                ],
                [
                    "****",
                    "****",
                    "****"
                ],
                [
                    "****",
                    "****",
                    "****"
                ]
            ]
        },
        {
            "code": "Giải năm",
            "items": [
                [
                    "*****"
                ],
                [
                    "*****"
                ],
                [
                    "*****"
                ]
            ]
        },
        {
            "code": "Giải tư",
            "items": [
                [
                    "*****",
                    "*****",
                    "*****",
                    "*****",
                    "*****",
                    "*****",
                    "*****"
                ],
                [
                    "*****",
                    "*****",
                    "*****",
                    "*****",
                    "*****",
                    "*****",
                    "*****"
                ],
                [
                    "*****",
                    "*****",
                    "*****",
                    "*****",
                    "*****",
                    "*****",
                    "*****"
                ]
            ]
        },
        {
            "code": "Giải ba",
            "items": [
                [
                    "*****",
                    "*****"
                ],
                [
                    "*****",
                    "*****"
                ],
                [
                    "*****",
                    "*****"
                ]
            ]
        },
        {
            "code": "Giải nhì",
            "items": [
                [
                    "*****"
                ],
                [
                    "*****"
                ],
                [
                    "*****"
                ]
            ]
        },
        {
            "code": "Giải nhất",
            "items": [
                [
                    "*****"
                ],
                [
                    "*****"
                ],
                [
                    "*****"
                ]
            ]
        },
        {
            "code": "Giải Đặc Biệt",
            "items": [
                [
                    "******"
                ],
                [
                    "******"
                ],
                [
                    "******"
                ]
            ]
        }
    ],
    "rightResults": [
        {
            "postCode": "A",
            "twoD": "**",
            "threeD": "***",
            "fiveD": "*****"
        },
        {
            "postCode": "B",
            "twoD": "**",
            "threeD": "***",
            "fiveD": "*****"
        },
        {
            "postCode": "C",
            "twoD": "**",
            "threeD": "***",
            "fiveD": "*****"
        },
        {
            "postCode": "D",
            "twoD": "**",
            "threeD": "***",
            "fiveD": "*****"
        },
        {
            "postCode": "F",
            "twoD": "**",
            "threeD": "***",
            "fiveD": "*****"
        },
        {
            "postCode": "I",
            "twoD": "**",
            "threeD": "***",
            "fiveD": "*****"
        },
        {
            "postCode": "N",
            "twoD": "**",
            "threeD": "***",
            "fiveD": "*****"
        },
        {
            "postCode": "P",
            "twoD": "**",
            "threeD": "***",
            "fiveD": "*****"
        }
    ],
    "slotResults": [
        {
            "columnNumber": 1,
            "release": "",
            "drawing": ""
        },
        {
            "columnNumber": 2,
            "release": "",
            "drawing": ""
        },
        {
            "columnNumber": 3,
            "release": "",
            "drawing": ""
        }
    ]
}

const startNight = {
    "drawCode": "98332",
    "drawAt": new Date(),
    "isNight": true,
    "isInited": true,
    "title": "15SP-5SP-1SP-11SP-14SP-13SP",
    "dayOfWeek": "Thứ hai",
    "header": null,
    "subHeader": null,
    "results": [
        {
            "code": "រង្វាន់ធំ",
            "items": [
                ["*****"]
            ]
        },
        {
            "code": "រង្វាន់លួងចិត្ត",
            "items": [
                ["*****"]
            ]
        },
        {
            "code": "Giải nhì",
            "items": [
                ["*****"],
                ["*****"]
            ]
        },
        {
            "code": "Giải ba",
            "items": [
                ["*****", "*****"],
                ["*****", "*****"],
                ["*****", "*****"],
            ]
        },
        {
            "code": "Giải tư",
            "items": [
                ["****", "****"],
                ["****", "****"]

            ]
        },
        {
            "code": "Giải năm",
            "items": [
                ["****", "****"],
                ["****", "****"],
                ["****", "****"]
            ]
        },
        {
            "code": "Giải sáu",
            "items": [
                ["***"],
                ["***"],
                ["***"]
            ]
        },
        {
            "code": "រង្វាន់ពិសេស",
            "items": [
                ["**"],
                ["**"],
                ["**"],
                ["**"]
            ]
        }
    ],
    "rightResults": [
        {
            "postCode": "A",
            "twoD": "**",
            "threeD": "***",
            "fiveD": "*****"
        },
        {
            "postCode": "B",
            "twoD": "**",
            "threeD": "***",
            "fiveD": "*****"
        },
        {
            "postCode": "C",
            "twoD": "**",
            "threeD": "***",
            "fiveD": "*****"
        },
        {
            "postCode": "D",
            "twoD": "**",
            "threeD": "***",
            "fiveD": "*****"
        },
        {
            "postCode": "F",
            "twoD": "**",
            "threeD": "***",
            "fiveD": "*****"
        },
        {
            "postCode": "I",
            "twoD": "**",
            "threeD": "***",
            "fiveD": "*****"
        },
        {
            "postCode": "J",
            "twoD": "**",
            "threeD": "***",
            "fiveD": "*****"
        },
        {
            "postCode": "N",
            "twoD": "**",
            "threeD": "***",
            "fiveD": "*****"
        },
        {
            "postCode": "P",
            "twoD": "**",
            "threeD": "***",
            "fiveD": "*****"
        },
        {
            "postCode": "Q",
            "twoD": "**",
            "threeD": "***",
            "fiveD": "*****"
        }
    ],
    "slotResults": [
        {
            "columnNumber": 1,
            "release": "",
            "drawing": ""
        }
    ]
}

const startKh = {
    "drawAt": new Date(),
    "drawCode": "",
    "drawLabel": "",
    "isInited": true,
    "results": [
        {
            "postCode": "A",
            "number": ""
        },
        {
            "postCode": "B",
            "number": ""
        },
        {
            "postCode": "C",
            "number": ""
        },
        {
            "postCode": "D",
            "number": ""
        }
    ]
}

const startSc = {
    "drawAt": new Date(),
    "drawCode": "",
    "drawLabel": "",
    "isInited": true,
    "results": [
        {
            "postCode": "A",
            "number": "*****"
        },
        {
            "postCode": "B",
            "number": "*****"
        },
        {
            "postCode": "C",
            "number": "*****"
        },
        {
            "postCode": "D",
            "number": "*****"
        },
        {
            "postCode": "E",
            "number": "*****"
        }
    ]
}

const startLeap5d = {
    "results": [
        [
            "*****"
        ],
        [
            "*****",
            "*****",
            "*****",
            "*****",
            "*****",
            "*****",
            "*****",
            "*****",
            "*****",
            "*****",
            "*****",
            "*****",
            "*****",
            "*****",
            "*****",
            "*****",
            "*****",
            "*****",
            "*****",
            "*****"
        ],
        [
            "*****",
            "*****",
            "*****",
            "*****",
            "*****",
            "*****"
        ]
    ],
    "drawTime": "07:30 PM",
    "drawDate": "2025-08-15",
    "drawAt": new Date(),
    "isPopular": false,
    "drawCode": "250001589",
    "shiftCode": "005",
    "status": "WAITING",
    "isInited": true,
}

const startLeap6d = {
    "results": [
        [
            "******"
        ],
        [
            "*****",
            "*****",
            "*****",
            "*****",
            "*****",
            "*****",
            "*****",
            "*****",
            "*****",
            "*****",
            "*****",
            "*****",
            "*****",
            "*****",
            "*****",
            "*****",
            "*****",
            "*****",
            "*****",
            "*****"
        ],
        [
            "******",
            "******",
            "******",
            "******",
            "******",
            "******"
        ]
    ],
    "drawTime": "05:30 PM",
    "drawDate": "2025-08-15",
    "drawAt": new Date(),
    "isPopular": false,
    "drawCode": "250001588",
    "shiftCode": "004",
    "status": "ACTIVE",
    "isInited": true,
}

// const start4RLo15 = {
//     "drawCode": "250001190",
//     "drawAt": new Date(),
//     "shiftCode": "029",
//     "isPopular": false,
//     "drawTime": "02:30 PM",
//     "status": "WAITING",
//     "isNight": false,
//     "isInited": true,
//     "title": [],
//     "dayOfWeek": "Thứ sáu",
//     "header": [
//         "Gia Lai",
//         "Ninh Thuận",
//         "Ninh Thuận",
//         "Thừa T. Huế"
//     ],
//     "subHeader": [
//         "2025-08-15 07:30:00",
//         "XSGL",
//         "XSNT",
//         "XSTTH"
//     ],
//     "results": [
//         {
//             "code": "Giải tám",
//             "items": [
//                 [
//                     "**"
//                 ],
//                 [
//                     "**"
//                 ],
//                 [
//                     "**"
//                 ],
//                 [
//                     "**"
//                 ]
//             ]
//         },
//         {
//             "code": "Giải bảy",
//             "items": [
//                 [
//                     "***"
//                 ],
//                 [
//                     "***"
//                 ],
//                 [
//                     "***"
//                 ],
//                 [
//                     "***"
//                 ]
//             ]
//         },
//         {
//             "code": "Giải sáu",
//             "items": [
//                 [
//                     "****",
//                     "****",
//                     "****"
//                 ],
//                 [
//                     "****",
//                     "****",
//                     "****"
//                 ],
//                 [
//                     "****",
//                     "****",
//                     "****"
//                 ],
//                 [
//                     "****",
//                     "****",
//                     "****"
//                 ]
//             ]
//         },
//         {
//             "code": "Giải năm",
//             "items": [
//                 [
//                     "*****"
//                 ],
//                 [
//                     "*****"
//                 ],
//                 [
//                     "*****"
//                 ],
//                 [
//                     "*****"
//                 ]
//             ]
//         },
//         {
//             "code": "Giải tư",
//             "items": [
//                 [
//                     "*****",
//                     "*****",
//                     "*****",
//                     "*****",
//                     "*****",
//                     "*****",
//                     "*****"
//                 ],
//                 [
//                     "*****",
//                     "*****",
//                     "*****",
//                     "*****",
//                     "*****",
//                     "*****",
//                     "*****"
//                 ],
//                 [
//                     "*****",
//                     "*****",
//                     "*****",
//                     "*****",
//                     "*****",
//                     "*****",
//                     "*****"
//                 ],
//                 [
//                     "*****",
//                     "*****",
//                     "*****",
//                     "*****",
//                     "*****",
//                     "*****",
//                     "*****"
//                 ]
//             ]
//         },
//         {
//             "code": "Giải ba",
//             "items": [
//                 [
//                     "*****",
//                     "*****"
//                 ],
//                 [
//                     "*****",
//                     "*****"
//                 ],
//                 [
//                     "*****",
//                     "*****"
//                 ],
//                 [
//                     "*****",
//                     "*****"
//                 ]
//             ]
//         },
//         {
//             "code": "Giải nhì",
//             "items": [
//                 [
//                     "*****"
//                 ],
//                 [
//                     "*****"
//                 ],
//                 [
//                     "*****"
//                 ],
//                 [
//                     "*****"
//                 ]
//             ]
//         },
//         {
//             "code": "Giải nhất",
//             "items": [
//                 [
//                     "*****"
//                 ],
//                 [
//                     "*****"
//                 ],
//                 [
//                     "*****"
//                 ],
//                 [
//                     "*****"
//                 ]
//             ]
//         },
//         {
//             "code": "Giải Đặc Biệt",
//             "items": [
//                 [
//                     "******"
//                 ],
//                 [
//                     "******"
//                 ],
//                 [
//                     "******"
//                 ],
//                 [
//                     "******"
//                 ]
//             ]
//         }
//     ],
//     "rightResults": [
//         {
//             "postCode": "A",
//             "twoD": "**",
//             "threeD": "***",
//             "fiveD": "*****"
//         },
//         {
//             "postCode": "B",
//             "twoD": "**",
//             "threeD": "***",
//             "fiveD": "*****"
//         },
//         {
//             "postCode": "C",
//             "twoD": "**",
//             "threeD": "***",
//             "fiveD": "*****"
//         },
//         {
//             "postCode": "D",
//             "twoD": "**",
//             "threeD": "***",
//             "fiveD": "*****"
//         },
//         {
//             "postCode": "F",
//             "twoD": "**",
//             "threeD": "***",
//             "fiveD": "*****"
//         },
//         {
//             "postCode": "I",
//             "twoD": "**",
//             "threeD": "***",
//             "fiveD": "*****"
//         },
//         {
//             "postCode": "N",
//             "twoD": "**",
//             "threeD": "***",
//             "fiveD": "*****"
//         },
//         {
//             "postCode": "P",
//             "twoD": "**",
//             "threeD": "***",
//             "fiveD": "*****"
//         }
//     ],
//     "slotResults": [
//         {
//             "columnNumber": 1,
//             "release": "",
//             "drawing": ""
//         },
//         {
//             "columnNumber": 2,
//             "release": "",
//             "drawing": ""
//         },
//         {
//             "columnNumber": 3,
//             "release": "",
//             "drawing": ""
//         },
//         {
//             "columnNumber": 4,
//             "release": "",
//             "drawing": ""
//         }
//     ]
// }

const btnType = {
    tc: [
        {
            label: "ចាប់ផ្តើមថ្ងៃ LO12",
            result: startLo12
        },
        {
            label: "ចាប់ផ្តើមថ្ងៃ LO15",
            result: startLo15
        },
        {
            label: "ចាប់ផ្តើមយប់",
            result: startNight
        },
    ],
    mt: [
        {
            label: "ចាប់ផ្តើមថ្ងៃ",
            result: startLo15
        },
        {
            label: "ចាប់ផ្តើមយប់",
            result: startNight
        },
    ],
    mc: [
        {
            label: "ចាប់ផ្តើមថ្ងៃ",
            result: startLo15
        },
        {
            label: "ចាប់ផ្តើមយប់",
            result: startNight
        },
    ],
    kh: [
        {
            label: "ចាប់ផ្តើម",
            result: startKh
        }
    ],
    sc: [
        {
            label: "ចាប់ផ្តើម",
            result: startSc
        }
    ],
    "tc_minhngoc": [
        {
            label: "ចាប់ផ្តើមថ្ងៃ LO15",
            result: startLo15
        },
        {
            label: "ចាប់ផ្តើមយប់",
            result: startNight
        }
    ],
    leap: [
        {
            label: "ចាប់ផ្តើម LEAP 5D",
            result: startLeap5d
        },
        {
            label: "ចាប់ផ្តើម LEAP 6D",
            result: startLeap6d
        }
    ],
    kp: [
        {
            label: "ចាប់ផ្តើមថ្ងៃ",
            result: startLo15
        },
        // {
        //     label: "ចាប់ផ្តើមថ្ងៃ 3ជួរ",
        //     result: startLo15
        // },
        // {
        //     label: "ចាប់ផ្តើមថ្ងៃ 4ជួរ",
        //     isLong: true,
        //     result: start4RLo15
        // },
        {
            label: "ចាប់ផ្តើមយប់",
            result: startNight
        },
    ]
}

export { btnType }